import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderCheckBoxTermsField } from '../../../form_helpers'
import { fetchMailLists, updateMailLists } from '../../../actions'
import { connect } from 'react-redux';
import { MAIL_LIST_ON_SIGNUP_ID } from '../../../constants';


class CommsVerifyForm extends Component {

    UNSAFE_componentWillMount() {
        this.props.fetchMailLists();
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if(nextProps.curLang !== this.props.curLang) {
            this.props.reset();
        }
        if(nextProps.success === true){
            this.props.handleOpenModal(this.props.strings.updateSuccess)
        }
    }

    render() {
        const { strings, mailListData, submitting, handleSubmit } = this.props;
        const trans = strings;
        let mailList = [];
        mailList.push(mailListData.mailing_lists ? mailListData.mailing_lists.find(x => x.id === MAIL_LIST_ON_SIGNUP_ID) : []);
        const isInitLoaded = Object.keys(mailListData).length > 0;

        return (

            <div className="form form--no-btm-pad form--pad-top">

                <header className="form__header form__header--low-space">
                    <h2 className="form__title">{trans.SignUpForLatest}</h2>
                </header>

                <div>
          			{ isInitLoaded && mailList && Object.keys(mailList).length && <form className="form__form" onSubmit={ handleSubmit }>
          					{
          						Object
          							.keys(mailList)
          							.map(key =>
          								<div key={key} className="form__checkbox-holder">
      											<Field
      												name={`mail_${mailList[key].id}`}
      												type="checkbox"
      												component={renderCheckBoxTermsField}
      												label={trans.mailingLists[key]}
      												on={trans.yes}
      												off={trans.no}
      												isChecked={mailList[key].subscribed_flag}
      											/>
          								</div>
          							)
          					}

                  <div className="form__actions">
          					<button className="form__submit form__submit--low-space btn" type="submit" disabled={submitting}>{strings.updatePreferences}</button>
          				</div>
          				</form>
          			}
                { !isInitLoaded &&
                  <div className="loading-content">{trans.loading}</div>
                }
          			</div>
            </div>
        )
    }
}

CommsVerifyForm = reduxForm({
    form: 'CommsVerifyForm',
    enableReinitialize: true, // Need to do this to allow initivalues to changes late due to asynch load
})(CommsVerifyForm);


CommsVerifyForm = connect(
    state => ({
        curLang: state.curLang,
        //initialValues: state.userData,
        //userData: state.userData,
        mailListData: state.mailListData,
        mailListError: state.mailListData.error,
        mailListUpdate: state.mailListUpdate
    }),
    { fetchMailLists, updateMailLists } // bind account loading action creator
)(CommsVerifyForm)

export default CommsVerifyForm;
